module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "galaxy"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contain clearfix"
  }, [_c('div', {
    staticClass: "galaxy-title"
  }, [_vm._v("\n\t\t\t新鲜入驻媒介\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "galaxy-content"
  }, [_vm._v("\n\t\t\t新鲜站，新视野，与广大站长和广告主实现共赢\n\t\t")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/huaban.png",
      "alt": "Planets"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "heidong",
    attrs: {
      "src": "/static/blackdong.png",
      "alt": "",
      "title": "点击刷新媒介"
    },
    on: {
      "click": function($event) {
        _vm.reload()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "335px",
      "left": "46.4%",
      "cursor": "pointer",
      "width": "28px"
    },
    attrs: {
      "id": "reload"
    },
    on: {
      "click": function($event) {
        _vm.reload()
      }
    }
  }, [_vm._v("点击刷新")]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "flip-list",
      "tag": "div"
    }
  }, _vm._l((_vm.data), function(item, index) {
    return _c('div', {
      key: item,
      staticClass: "media-point",
      style: ({
        top: _vm.site[index][0],
        left: _vm.site[index][1]
      })
    }, [(_vm.$route.params.type === "web") ? _c('a', {
      attrs: {
        "href": item.previewUrl,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.siteName))]) : _c('div', {
      staticStyle: {
        "cursor": "default"
      }
    }, [_vm._v(_vm._s(item.siteName))])])
  }))], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header",
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "canvaszz"
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvas"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b6d5250a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/medianav/galaxy/galaxy.vue
// module id = 453
// module chunks = 2